export { DMS_MODULE, MODULE_API, API_ND_SKLAD } from '../constants';
export const NAME = 'NdCenik';
export const CRUMB_LABEL_KEY = 'edtNDCenik';
export const REPORTS = 'Reports';
export const PART_PRICING_LOG = 'PartPricingLog';
export const MAX_SIZE = 2000000000;
export const FILE_TYPE = 'csv';
export const BULK_PARTS_UPLOAD = 'Bulk Parts Upload';

export const DEPENDENT_TABLES_ALL = <const>[
	PART_PRICING_LOG,
];
export type DependentTableNames = typeof DEPENDENT_TABLES_ALL[number];
